import React, { useEffect, useState } from 'react';
import { Checkbox } from './ui/checkbox';
import { Label } from './ui/label';
import { resourcesAPI } from '../lib/api';

let cache = null;

export const MemberPicker = ({ value, onChange, testId = 'member-picker' }) => {
  const [members, setMembers] = useState(cache || []);
  useEffect(() => { if (!cache) resourcesAPI.teamMembers().then((m) => { cache = m; setMembers(m); }).catch(() => {}); }, []);
  const toggle = (id) => onChange(value.includes(id) ? value.filter((x) => x !== id) : [...value, id]);
  return (
    <div className="flex flex-wrap gap-x-4 gap-y-2" data-testid={testId}>
      {members.map((m) => (
        <label key={m.id} className="flex items-center gap-2 text-sm cursor-pointer">
          <Checkbox checked={value.includes(m.id)} onCheckedChange={() => toggle(m.id)} data-testid={`${testId}-${m.id}`} />
          <Label className="cursor-pointer font-normal">{m.name}</Label>
        </label>
      ))}
      {!members.length && <span className="text-xs text-muted-foreground">No hay miembros del equipo.</span>}
    </div>
  );
};
